import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { getContentCategory as onGetAssetCategories, addNewContentCategory as onAddNewContentCategory, updateContentCategory as onUpdateContentCategory, deleteContentCategory as onDeleteContentCategory, getContentCategoryLoading } from "../../../store/contentCategory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import defaultImg from "../../../assets/images/upload.png";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import { resetAssetCategoryState } from "../../../store/actions";

const typeSelectData = [
  {
    options: [
      { label: "Berita", value: "Berita" },
      { label: "Banner", value: "Banner" },
      { label: "Single Banner", value: "Single Banner" },
      { label: "Bantuan", value: "Bantuan" },
      { label: "About", value: "About" },
      { label: "Term", value: "Term" },
      { label: "Privacy", value: "Privacy" },
      { label: "Contact Us", value: "Contact Us" },
      { label: "KPR", value: "KPR" },
      { label: "Location", value: "Location" },
    ],
  },
];

const ContentCategory = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, contentCategories, isContentCategoryCreated, isContentCategorySuccess, loading, error, companies, companyLoading, clients, clientLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    contentCategories: state.ContentCategory.contentCategories,
    isContentCategoryCreated: state.ContentCategory.isContentCategoryCreated,
    isContentCategorySuccess: state.ContentCategory.isContentCategorySuccess,
    loading: state.ContentCategory.loading,
    error: state.ContentCategory.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [contentCategoryList, setContentCategoryList] = useState([]);
  const [contentCategory, setContentCategory] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [logo, setLogo] = useState(defaultImg);
  const [modalMedia, setModalMedia] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (contentCategory) => {
    setContentCategory(contentCategory);
    setDeleteModal(true);
  };

  const handleDeleteContentCategory = () => {
    if (contentCategory) {
      dispatch(onDeleteContentCategory(contentCategory));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setContentCategoryList(contentCategories);
  // }, [contentCategories]);

  useEffect(() => {
    if (!isEmpty(contentCategories)) {
      let filteredAssetCategories = contentCategories;
      if (activeTypeTab !== "all") {
        filteredAssetCategories = contentCategories.filter((contentCategory) => contentCategory.content_category_status.name === activeTypeTab);
      }
      setContentCategoryList(filteredAssetCategories);
    }
    let arr = [{ value: null, label: "No Parent" }];
    contentCategories.forEach((element) => {
      arr.push({ value: element.id, label: element.name });
    });
    setParentList(arr);
  }, [contentCategories]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAssetCategories = contentCategories;
      if (type !== "all") {
        filteredAssetCategories = contentCategories.filter((contentCategory) => contentCategory.content_category_status.name === type);
      }
      setContentCategoryList(filteredAssetCategories);
    }
  };

  useEffect(() => {
    dispatch(resetAssetCategoryState());
    dispatch(onGetAssetCategories());
  }, []);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  // useEffect(() => {
  //   setContentCategory(contentCategories);
  // }, [contentCategories]);

  useEffect(() => {
    if (!isEmpty(contentCategories)) {
      // setContentCategory(contentCategories);
      setIsEdit(false);
    }
  }, [contentCategories]);

  // useEffect(() => {
  //   setContentCategoryList(contentCategories);
  // }, [contentCategories]);

  // useEffect(() => {
  //   if (!isEmpty(contentCategories)) setContentCategoryList(contentCategories);
  // }, [contentCategories]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCompanyList([]);
      setContentCategory(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    validation.setFieldValue("image", file.filename);

    toggleMedia();
  };

  const handleContentCategoryClick = useCallback(
    (arg) => {
      const contentCategory = arg;
      setContentCategory({
        id: contentCategory.id,
        name: contentCategory.name,
        sort_order: contentCategory.sort_order,
        image: contentCategory.image,
        type: contentCategory.type && {
          label: contentCategory.type,
          value: contentCategory.type,
        },
        description: contentCategory.description,
        status: contentCategory.content_category_status.id,
        company: contentCategory.content_category_company && {
          label: contentCategory.content_category_company.name,
          value: contentCategory.content_category_company.id,
        },
        client: contentCategory.content_category_client && {
          label: contentCategory.content_category_client.name,
          value: contentCategory.content_category_client.id,
        },
        parent: contentCategory.par_content_category
          ? {
              label: contentCategory.par_content_category.name,
              value: contentCategory.par_content_category.id,
            }
          : "",
      });

      switch (userType) {
        case "admin":
          setIsDisabledUserType(false);
          break;

        default:
          if (userType === "client") {
            // handleGetCompany(contentCategory.content_category_client ? contentCategory.content_category_client.id : "");
          }
          setIsDisabledUserType(true);
          break;
      }

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (contentCategory && contentCategory.name) ?? "",
      type: (contentCategory && contentCategory.type) ?? "",
      sort_order: (contentCategory && contentCategory.sort_order) ?? "",
      status: (contentCategory && contentCategory.status) || "1",
      description: (contentCategory && contentCategory.description) ?? "",
      company: contentCategory && contentCategory.company,
      client: contentCategory && contentCategory.client,
      parent: contentCategory && contentCategory.parent,
      image: (contentCategory && contentCategory.image) ?? "",
    },
    validationSchema: Yup.object({
      //   name: Yup.string()
      //     .required("Please Enter ContentCategory Name")
      //     .nullable(true),
      //   type: Yup.object().required("Please Pick Type").nullable(true),
      //   company: Yup.object().required("Please Pick Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getContentCategoryLoading());
      if (isEdit) {
        const updateContentCategory = {
          id: contentCategory ? contentCategory.id : 0,
          name: values.name,
          sort_order: values.sort_order,
          type: values.type.value,
          description: values.description,
          statusId: values.status,
          companyId: values.company.value,
          clientId: values.client.value,
          parentId: values.parent ? values.parent.value : null,
          image: values.image,
        };
        dispatch(onUpdateContentCategory(updateContentCategory));
        validation.resetForm();
      } else {
        const newContentCategory = {
          name: values.name,
          sort_order: values.sort_order,
          type: values.type.value,
          description: values.description,
          statusId: values.status,
          companyId: values.company.value,
          clientId: values.client.value,
          parentId: values.parent ? values.parent.value : null,
          image: values.image,
        };
        dispatch(onAddNewContentCategory(newContentCategory));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteContentCategory(element.value));
    });
    checkall.checked = false;
  };

  const checkType = (val) => {
    switch (val) {
      case "Berita":
        return {
          label: "Berita",
          value: "Berita",
        };
      case "Banner":
        return {
          label: "Banner",
          value: "Banner",
        };
      case "Single Banner":
        return {
          label: "Single Banner",
          value: "Single Banner",
        };
      case "Bantuan":
        return {
          label: "Bantuan",
          value: "Bantuan",
        };

      case "About":
        return {
          label: "About",
          value: "About",
        };
      case "Term":
        return {
          label: "Term",
          value: "Term",
        };
      case "Privacy":
        return {
          label: "Privacy",
          value: "Privacy",
        };
      case "Contact Us":
        return {
          label: "Contact Us",
          value: "Contact Us",
        };
      case "Location":
        return {
          label: "Location",
          value: "Location",
        };
      case "KPR":
        return {
          label: "KPR",
          value: "KPR",
        };
      default:
        break;
    }
  };
  // Column
  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox" className="dataCheckbox form-check-input" value={cellProps.row.original.id} />;
        },
        id: "#",
      },
      {
        Header: "Content Category",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Content Type",
        accessor: "type",
        filterable: true,
        Cell: (cell) => checkType(cell.row.original.type).label,
      },
      {
        Header: "Parent Content Category",
        accessor: "par_content_category.name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "content_category_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateContentCategory") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  const contentCategoryData = cellProps.row.original;
                  handleContentCategoryClick(contentCategoryData);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteContentCategory") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const contentCategoryData = cellProps.row.original;
                  onClickDelete(contentCategoryData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [handleContentCategoryClick, userRole, userType]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: contentCategoryList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleContentCategoryStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAssetCategories(param));
  }

  const setInputType = (type) => {
    if (userData) {
      switch (type) {
        case "user":
          setContentCategory({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;
        case "client":
          setContentCategory({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
          });
          // handleGetCompany(userData.clientId);
          setIsDisabledUserType(true);
          break;
        case "company":
          setContentCategory({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;

        default:
          setContentCategory("");
          setIsDisabledUserType(false);
          break;
      }
    }
  };

  const handleResetFilter = () => {
    setFilterDate(null);
    contentCategoryList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetAssetCategoryState());
    dispatch(onGetAssetCategories());
  };

  document.title = "Content Categories | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={contentCategoryList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteContentCategory} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Kontent" pageTitle="Kategori" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createContentCategory") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setInputType(userType);
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i>Export
            </button>
            <button className={userType === "admin" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteContentCategory") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="contentCategoryList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i>All Content Categories
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleContentCategoryStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Content Category" : "Add Content Category"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              placeholder="Pilih Grup Usaha"
                              isDisabled={isDisabledUserType}
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                // handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={companyList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Name
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Type
                            </Label>
                            <Select
                              name="type"
                              value={validation.values.type}
                              placeholder="Select Type"
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeSelectData}
                              invalid={validation.touched.type && validation.errors.type ? true : false}
                            ></Select>
                            {validation.touched.type && validation.errors.type ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.type}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="parent" className="form-label">
                              Parent Content Category
                            </Label>
                            <Select
                              name="parent"
                              value={validation.values.parent}
                              placeholder="Enter ContentCategory"
                              onChange={(e) => {
                                validation.setFieldValue("parent", e);
                              }}
                              options={parentList}
                            ></Select>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="sort_order-field" className="form-label">
                              Sort Order
                            </Label>
                            <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Enter Title" type="input" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sort_order ?? ""} />
                            {validation.touched.sort_order && validation.errors.sort_order ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.sort_order}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="active-status" className="form-label">
                              Status
                            </Label>
                            <Input name="status" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.status || "1"}>
                              {statusActiveData.map((item, key) => (
                                <React.Fragment key={key}>
                                  {item.options.map((item, key) => (
                                    <option value={item.value} key={key}>
                                      {item.label}
                                    </option>
                                  ))}
                                </React.Fragment>
                              ))}
                            </Input>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={6} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>

                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="image" className="form-label">
                              Image
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                // setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Content Category"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContentCategory;
